import { defineStore } from 'pinia'
import { inject } from 'vue';

export const usePackagePriceStore = defineStore('packagePriceStore', () => {
  const whitelabelConfig= require('../../whitelabel.config');
  const globalDiscountAvailable = inject('discountAvailable');

  const calculatePrices = (brandTheme, data) => { // packages, data, couponDiscountAvailable
    if (!brandTheme || !data) return null

    const packageData = {}
    const discountSettings = whitelabelConfig[brandTheme]?.discountSettings
    let price = 0
    let einmaligesPrice = 49.00 // Default einmaliges price

    let packages = data.reversedAppPackages?.packages || [];
    let couponDiscountAvailable = data.appPackages?.couponDiscountAvailable

    Object.entries(packages)?.forEach(([packageName, packagePrices]) => {

      if (packageName === 'basis' && (data.s3.value === 'Ja' && data.s4.value === 'Zuhause')) {
        einmaligesPrice = 0.00;
      }

      packageData[packageName] = {
        'priceFromApi': packagePrices?.price, // Default monatlicher price from API
        'priceWithDiscountFromApi': packagePrices?.priceWithDiscount,
        'einmaligesPrice': einmaligesPrice,
        'hasMonatlicherDiscount': false,
        'hasEinmaligesDiscount': false,
        'discountedPrices': {}
      }

      /****************************** EXCEPTIONS FOR WHITELABELS *****************************************************/
      /******** BELOW ARE CUSTOM RULES FOR WHITELABLES THAT HAVE TO APPLY IN ORDER FOR THE DISCOUNTS TO WORK *********/
      /***************************************************************************************************************/


      /**************************************** default **************************************************************/
      /* Rules: 1. couponDiscountAvailable variable value has to be true.                                       ******/
      /*        1.1. couponDiscountAvailable is received from API /hausnotruf/api/services?id=xxxxx                  */
      /***************************************************************************************************************/

      if (brandTheme === 'default' && !couponDiscountAvailable) {
        return packageData
      }

      /****************************** landingpage-bawue-messe *********************************************************/
      /* Rules: 1. User selected zipcode has to be within 'Landesverband Baden-Württemberg' region                    */
      /*        2. Step 3 value has to be 'Ja'                                                                        */
      /*        3. If any of the above conditions is not met then do not apply the discount                           */
      /****************************************************************************************************************/

      if (brandTheme === 'landingpage-bawue-messe' &&
        (!data.contact?.region.includes('Landesverband Baden-Württemberg') || data.s3?.value.includes('Ja'))) {
        return packageData
      }

      /*********************************** corporatebenefits *********************************************************/
      /* Rules: 1. User has to apply a valid discount code on step 5                                                 */
      /*        2. If any of the above conditions is not met then do not apply the discount                          */
      /***************************************************************************************************************/

      if (brandTheme === 'corporatebenefits' && !globalDiscountAvailable.value) {
        return packageData
      }

      if (brandTheme === 'hanova') {

        if (data.contact?.region.includes('Landesverband Niedersachsen/Bremen')) {

          if (packageData?.basis) {
            packageData.basis.priceFromApi = 25.50;
          }
        }
      }

      discountSettings?.forEach((discount) =>  {
        if (discount.discountAppliesToPackages.includes(packageName)) {

          if (discount.discountType === 'percentage') {
            price = packageData[packageName]?.priceFromApi

            /********************************************** hanova **********************************************************/
            /* Rules:                                                                                                       */
            /*  1. Discounts only apply if user selects step 2 zipcode that falls within Landesverband Niedersachsen/Bremen */
            /*  2. If step 3 is Ja then we apply 25.50 additional fixed discount to already discounted (25%) prices         */
            /****************************************************************************************************************/

            if (brandTheme === 'hanova') {

              price = packageData[packageName]?.priceFromApi

              if (data.contact?.region.includes('Landesverband Niedersachsen/Bremen')) {

                let careDegreeDiscount = data.s3.value.includes('Ja') ? 25.50 : 0;

                if (packageData?.komfort) {
                  packageData.komfort.priceFromApi = 59.00 - careDegreeDiscount
                }

                if (packageData?.premium) {
                  packageData.premium.priceFromApi = 89.00 - careDegreeDiscount
                }

                if (data?.s3.value.includes('Ja')) {

                  if (packageData?.premium) {
                    price = 89.00
                    price *= discount.discountAmount
                    price -= 25.50
                  }

                  if (packageData?.komfort) {
                    price = 59.00
                    price *= discount.discountAmount
                    price -= 25.50
                  }

                } else {
                  price *= discount.discountAmount
                }
              }

            } else {
              price *= discount.discountAmount
          }


          }

          if (discount.discountType === 'fixed') {
            price = discount.discountAmount
          }

          discount.discountAppliesToPriceTypes.forEach((priceType) =>  {

            if ((brandTheme === 'meravis' || brandTheme === 'wohnbau-kleefeld-buchholz') && priceType === 'monatlicher') {

              if (data?.s3.value.includes('Ja')) {
                price *= 0.90;
              } else {
                let customDiscount = price - 25.50;
                customDiscount = customDiscount - (customDiscount * 0.90);
                price -= customDiscount;
              }

            }

            if (priceType === 'monatlicher' && price < packagePrices.price) {
              packageData[packageName]['hasMonatlicherDiscount'] = true
            }

            if (priceType === 'einmaliges' && price < einmaligesPrice) {
              packageData[packageName]['hasEinmaligesDiscount'] = true
            }

            packageData[packageName].discountedPrices[priceType] = price;

          })
        }
      })
    })

    return packageData
  }

  const updatePrices = (brandTheme, data) => {
    return calculatePrices(brandTheme, data)
  }

  return {
    updatePrices
  }
})
